import { findComposePlugins } from '../plugins/ComposePlugins';
import { getTotalRecipientCount } from './viewStateUtils';
export var ComposeControl;
(function (ComposeControl) {
    ComposeControl[ComposeControl["From"] = 1] = "From";
    ComposeControl[ComposeControl["RecipientWellTo"] = 2] = "RecipientWellTo";
    ComposeControl[ComposeControl["RecipientWellCc"] = 3] = "RecipientWellCc";
    ComposeControl[ComposeControl["RecipientWellBcc"] = 4] = "RecipientWellBcc";
    ComposeControl[ComposeControl["SubjectLine"] = 5] = "SubjectLine";
    ComposeControl[ComposeControl["AttachmentWell"] = 6] = "AttachmentWell";
    ComposeControl[ComposeControl["Editor"] = 7] = "Editor";
})(ComposeControl || (ComposeControl = {}));
export default function getAutoFocusControl(viewState) {
    var plugins = findComposePlugins(viewState);
    var hasCursorSnapshot = plugins && plugins.contentOperationPlugin.hasCursorSnapshot();
    if (!hasCursorSnapshot && !viewState.isInlineCompose) {
        if (getTotalRecipientCount(viewState) == 0) {
            return 2 /* RecipientWellTo */;
        }
        else if (!viewState.subject) {
            return 5 /* SubjectLine */;
        }
    }
    return 7 /* Editor */;
}
//# sourceMappingURL=getAutoFocusControl.js.map